import { pick, omit } from 'lodash-es';
import { FILTER_RULE_ENUMS, FILTER_OPERATOR_ENUMS, LIMIT } from '@constants';

export const getServicePointsQueryParams = (payload = {}) => {
  if (!payload?.pageSize) {
    payload.pageSize = LIMIT;
  }
  if (!payload?.page) {
    payload.page = '1';
  }

  return pick(payload, ['page', 'pageSize', 'order', 'orderBy']);
};

const BOOLEAN_VALUES = {
  certified: true,
  notCertified: false,
};

const FIELDS_MAP = {
  certified: 'partnershipInfo.isCertified',
  status: 'status',
  workType: 'supportedWorkTypes',
  manufacturer: 'supportedManufacturers',
  insurance: 'supportedInsurances',
};

export const getServicePointsRequestPayload = (
  payload = {},
  modalFiltersRules = null
) => {
  // Exclude empty string values (All option) for certified filter
  const cleanedPayload = { ...payload };
  if (cleanedPayload.certified === '') {
    delete cleanedPayload.certified;
  }
  if (cleanedPayload.status === '') {
    delete cleanedPayload.status;
  }

  const fields =
    omit(cleanedPayload, ['page', 'pageSize', 'order', 'orderBy', 'query']) ||
    {};
  const numberFields = ['status'];
  const booleanFields = ['certified'];
  const multyFilterStringFields = ['insurance'];
  const multyFilterNumberFields = ['workType', 'manufacturer'];

  const _getValue = ({ field }) => {
    if (booleanFields.includes(field)) {
      return BOOLEAN_VALUES[cleanedPayload[field]];
    }
    if (numberFields.includes(field)) {
      return Number(cleanedPayload[field]);
    }
    if (multyFilterStringFields.includes(field)) {
      const values = cleanedPayload[field]?.split(',') || [];
      return values;
    }
    if (multyFilterNumberFields.includes(field)) {
      return cleanedPayload[field]?.split(',').map((item) => Number(item));
    }
    return cleanedPayload[field];
  };
  const _getType = ({ field }) => {
    if (
      multyFilterStringFields.includes(field) ||
      multyFilterNumberFields.includes(field)
    ) {
      return FILTER_RULE_ENUMS.IsAnyOfRuleType;
    }
    return FILTER_RULE_ENUMS.ComparableRuleType;
  };

  const value = [
    ...Object.keys(fields).map((field) => ({
      field: FIELDS_MAP[field],
      operator: FILTER_OPERATOR_ENUMS['='],
      type: _getType({ field }),
      value: _getValue({ field }),
    })),
  ];

  value.push(...(modalFiltersRules?.value || []));

  if (value.length) {
    return {
      type: FILTER_RULE_ENUMS.AndRuleType,
      field: null,
      operator: null,
      value,
    };
  }

  return {
    type: FILTER_RULE_ENUMS.EmptyRuleType,
  };
};
